import React, { Component } from 'react';
import DefiSidebar from '../sidebar/DefiSidebar';
import DefiHeader from '../header/DefiHeader';
import AppBanner from '../banner/AppBanner';
import TestEnvironmentBanner from '../banner/TestEnvironmentBanner';
import { withStyles } from '@material-ui/core/styles';
import { fromJS } from 'immutable';
const nullify = () => null;
const styles = () => ({
  container: {
    height: '100%'
  },
  default: {
    height: '100%'
  },
  padding: {
    marginTop: 78,
    padding: 10
  },
  push: {
    marginLeft: 300
  }
});
class DefiLayout extends Component {
  constructor(props) {
    super(props);
    this.setMediaData = () => {
      if (this.props.sidebarContent) {
        this.setState({
          open: this.mql.matches,
          mobile: !this.mql.matches
        });
      } else {
        this.setState({
          mobile: !this.mql.matches
        });
      }
    };
    this.toggleSidebar = bool => {
      if (bool !== undefined) {
        return this.setState({
          open: bool
        });
      }
      this.setState({
        open: !this.state.open
      });
    };
    this.renderSidebar = () => {
      if (this.props.sidebarContent) {
        return /*#__PURE__*/React.createElement(DefiSidebar, {
          open: this.state.open
        }, this.props.sidebarContent);
      }
    };
    this.mql = window.matchMedia("(min-width: ".concat(props.mobileWidth, "px)"));
    this.state = {
      open: false,
      mobile: !this.mql.matches
    };
  }
  componentDidMount() {
    if (localStorage.mobile === 'false') {
      return this.setState({
        open: true,
        mobile: false
      });
    }
    this.mql.addListener(this.setMediaData);
    this.setMediaData();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.mobileWidth !== this.props.mobileWidth) {
      if (localStorage.mobile !== 'false') {
        this.mql.removeListener(this.setMediaData);
        this.mql = window.matchMedia("(min-width: ".concat(this.props.mobileWidth, "px)"));
        this.mql.addListener(this.setMediaData);
        this.setMediaData();
      }
    }
    if (!this.props.sidebarContent && this.state.open) {
      this.setState({
        open: false
      });
    }
  }
  componentWillUnmount() {
    this.mql.removeListener(this.setMediaData);
  }
  render() {
    const _this$props = this.props,
      classes = _this$props.classes,
      headerClick = _this$props.headerClick,
      headerCenter = _this$props.headerCenter,
      headerLinks = _this$props.headerLinks,
      mobileWidth = _this$props.mobileWidth,
      sidebarContent = _this$props.sidebarContent,
      logo = _this$props.logo,
      logoLink = _this$props.logoLink,
      children = _this$props.children,
      noPadding = _this$props.noPadding,
      headerContainerClass = _this$props.headerContainerClass,
      defaultClass = _this$props.defaultClass,
      hideHeaderSidebar = _this$props.hideHeaderSidebar;
    const _this$state = this.state,
      open = _this$state.open,
      mobile = _this$state.mobile;
    const hideHeaderSidebarContent = hideHeaderSidebar == true;
    const contentClickProp = mobile && open && {
      onClick: () => this.toggleSidebar(false)
    };
    const push = open && !mobile && !hideHeaderSidebarContent ? classes.push : '';
    const padding = noPadding ? '' : classes.padding;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container,
      "data-testid": "defi-layout"
    }, /*#__PURE__*/React.createElement(TestEnvironmentBanner, null), /*#__PURE__*/React.createElement(AppBanner, null), !hideHeaderSidebarContent && /*#__PURE__*/React.createElement(DefiHeader, {
      toggleSidebar: sidebarContent ? this.toggleSidebar : null,
      headerClick: headerClick,
      center: headerCenter,
      right: headerLinks,
      mobileWidth: mobileWidth,
      logo: logo,
      logoLink: logoLink,
      headerContainerClass: headerContainerClass
    }), !hideHeaderSidebarContent && this.renderSidebar(), /*#__PURE__*/React.createElement("div", Object.assign({
      className: "".concat(classes.default, " ").concat(padding, " ").concat(push, " ").concat(defaultClass)
    }, contentClickProp), children));
  }
}
DefiLayout.defaultProps = {
  headerLinks: fromJS([]),
  sidebarContent: null,
  headerCenter: null,
  mobileWidth: 1250,
  children: null,
  headerClick: nullify,
  logo: '',
  logoLink: '',
  noPadding: false
};
export default withStyles(styles)(DefiLayout);